/**
 * Runtime configuration from Vite env vars. Everything here ships in the browser bundle,
 * so nothing secret belongs in it: Cognito pool and client ids are public identifiers by
 * design, and the frontend never holds AWS credentials.
 */
export const config = {
  userPoolId: (import.meta.env['VITE_COGNITO_USER_POOL_ID'] as string | undefined) ?? '',
  clientId: (import.meta.env['VITE_COGNITO_CLIENT_ID'] as string | undefined) ?? '',
} as const;

export const isAuthConfigured = (): boolean => config.userPoolId !== '' && config.clientId !== '';
